import getApiClient from 'src/utils/getApiClient'
import type {
  LpuSlotsBySpecialityRequest,
  LpuSlotsBySpecialityResponse,
} from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsSchedule/api/apiLpuSlotsBySpeciality.types'

const apiClient = getApiClient()

const apiLpuSlotsBySpeciality = {
  post(payload: LpuSlotsBySpecialityRequest) {
    return apiClient.post<LpuSlotsBySpecialityResponse>(
      '/ajax/schedule/slots_bulk_by_specialities/',
      payload,
    )
  },
}

export default apiLpuSlotsBySpeciality
